// extracted by mini-css-extract-plugin
export var brand = "_76-9";
export var compact = "_76-6";
export var extraSmall = "_76-7";
export var icon = "_76-0";
export var large = "_76-4";
export var light = "_76-1";
export var medium = "_76-5";
export var outline = "_76-b";
export var primaryDark = "_76-a";
export var primaryLight = "_76-8";
export var primaryModern = "_76-c";
export var success = "_76-2";
export var successSolid = "_76-3";